import React from "react";
import SafeCallComponent from "../../lab-orders/LabOrderItem/children/SafeCallComponent";
const PharmacyWaitingForPaymentActions = (props) => {
    return (
        <>
            <div className="flex-column pharmacy-actions-buttons">
               {/* <SafeCallComponent order={props} />*/}
            </div>
        </>
    )
};

export default PharmacyWaitingForPaymentActions;
